import type { ThemeVariantMap } from "@/theme/types";

import { olearysDarkTheme } from "./olearys.dark";
import { olearysLightTheme } from "./olearys.light";

export const olearysTheme: ThemeVariantMap = {
  LIGHT: olearysLightTheme,
  DARK: olearysDarkTheme,
} as const;
